/**
 * Modelo que guarda todas as informações e formatações
 * necessárias para que um componente seja desenhado no PDF
 */
export default class ComponentPDF {
    constructor(action, options, config) {
        this.action = action;
        this.options = options;
        this.config = config;
    }
}
